import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ExportSurveyDialogData } from '../dialogs-data/export-survey-dialog-data';
import { ExportSurveyDialogComponent } from '../dialogs/export-survey-dialog/export-survey-dialog.component';

@Injectable()
export class ExportSurveyDialogService {
    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<ExportSurveyDialogComponent>;

    open(exportSurveyDialogData: ExportSurveyDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '50%';
        matDialogConfig.data = exportSurveyDialogData;
        matDialogConfig.disableClose = true;
        matDialogConfig.hasBackdrop = true;
        this.matDialogRef = this.dialog.open(ExportSurveyDialogComponent, matDialogConfig);
    }

    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
